import $ from "jquery";
import Choices from "choices.js";
var Switchery = require('switchery');
$(document).ready(function () {
    if ($("select").length) {
        $('select').each(function (k, v) {
            var select = new Choices(v, {
                removeItemButton: false
            });
            if ($(v).hasClass("select-type")) {
                $(v).on("change", function () {
                    var task = $(v).parents(".Task");
                    var qty = task.find(".qty");
                    var commission = task.find(".commission");
                    var type = task.find(".type").find("select").val();
                    switch (type) {
                        case "production":
                            qty.addClass("hidden");
                            commission.removeClass("hidden");
                            if (qty.find("input").val() == "") {
                                qty.find("input").val(1);
                            }
                            break;
                        default:
                            commission.addClass("hidden");
                            qty.removeClass("hidden");
                            if (commission.find("input").val() == "") {
                                commission.find("input").val(0);
                            }
                            break;
                    }
                });
            }
        });
    }
    if ($("#document_form_isRecurrent").length) {
        $("#document_form_isRecurrent").on("change", function (e) {
            var elm = e.currentTarget;
            if ($(elm).is(":checked")) {
                $(".recurrence").addClass("active");
            }
            else {
                $(".recurrence").removeClass("active");
            }
        });
    }
    // let elems = Array.prototype.slice.call(document.querySelectorAll('.js-switch')); 
    // elems.forEach(function(html) {
    //     let switchery = new Switchery(html, { color: '#FF0358' });
    //     $(switchery).on("click",() => {
    //         console.log("changed");
    //     });
    // });
});
